import React from 'react';
import Profilepage from '../components/Profilepage'
import DashboardLayout from './layout/dashboardLayout';

const AdminProfilePage = () => {
    return (
        <DashboardLayout>
            <Profilepage />
        </DashboardLayout>
    )
};
export default AdminProfilePage;